import React, { ComponentType } from "react";
import { useTheme } from "styled-components";
import NewLookSettingsLayout from "features/settings/NewLook/NewLookSettingsLayout.tsx";

/**
 * Wraps a settings page in the new-look settings frame. With the classic look
 * the page renders exactly as before.
 */
export const withNewLookSettingsLayout = <P extends object>(
  Component: ComponentType<P>
) => {
  const WithSettingsLayout = (props: P) => {
    const { isNewLook } = useTheme();
    if (!isNewLook) return <Component {...props} />;
    return (
      <NewLookSettingsLayout>
        <Component {...props} />
      </NewLookSettingsLayout>
    );
  };
  return WithSettingsLayout;
};
